import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { TransitStatus } from '@e-origin/shared';

import { TransitListItemSchema } from '../transit/schemas';
import { AdminTransitCriteriaSchema } from './schemas';

const c = initContract();

export const adminTransitContract = c.router({
  retrieveTransits: {
    method: 'POST',
    path: '/admin/transits',
    body: z.object({ criteria: AdminTransitCriteriaSchema }),
    responses: {
      200: z.object({
        data: z.object({
          transitsList: z.array(TransitListItemSchema),
          totalItems: z.number(),
        }),
      }),
    },
  },
  exportTransit: {
    method: 'GET',
    path: '/admin/export-transit/:transitId',
    pathParams: z.object({ transitId: z.string() }),
    responses: {
      200: c.otherResponse({
        contentType: 'application/zip',
        body: z.unknown(),
      }),
    },
  },
  importTransit: {
    method: 'POST',
    path: '/admin/import-transit',
    contentType: 'multipart/form-data',
    body: z.object({
      customerId: z.string(),
      templateId: z.string(),
      declarantId: z.string(),
      userId: z.string(),
      resetCustomsData: z.string(),
    }),
    responses: {
      201: z.object({ message: z.string() }),
      400: z.object({ message: z.string() }),
    },
  },
  updateTransitStatus: {
    method: 'PATCH',
    path: '/admin/transit-status/:transitId',
    pathParams: z.object({ transitId: z.string() }),
    body: z.object({ status: z.nativeEnum(TransitStatus) }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  delete: {
    method: 'DELETE',
    path: '/admin/transits/:transitId',
    pathParams: z.object({ transitId: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
});

export type AdminImportTransitBody = z.infer<typeof adminTransitContract.importTransit.body>;
